import React from 'react';
import { Box } from '@mui/material';

/** Full-bleed map: cancel main `p: 2` so the iframe fills the content area (no inner box / white gap). */
const VahanMapPage = () => (
  <Box
    sx={(theme) => ({
      // Pull into the main padding so the map reaches the edges of the content column
      mx: -2,
      mt: -2,
      mb: -2,
      width: `calc(100% + ${theme.spacing(4)})`,
      // Below fixed AppBar: main uses mt: 8 (64px); vertical negative margins reclaim top/bottom padding
      height: `calc(100vh - ${theme.spacing(8)})`,
      minHeight: 0,
      overflow: 'hidden',
    })}
  >
    <Box
      component="iframe"
      title="Vahan Map"
      src="/vahanmap.html"
      sx={{ width: '100%', height: '100%', border: 0, display: 'block' }}
    />
  </Box>
);

export default VahanMapPage;
